import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useEffect, useState } from 'react'
import './AddPayMethod.scss'
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {ReactComponent as Bank} from '../../assets/new-icons/bank2.svg';
import {ReactComponent as Card} from '../../assets/new-icons/card.svg';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import Step1 from './steps/step1';
import Step2 from './steps/step2';
import Step3 from './steps/step3';
import Step4 from './steps/step4';
import Step5 from './steps/step5';


function AddPayMethod() {
    const navigate = useNavigate()
    const [step, setStep] = useState(0)
    const [disabled, setDisabled] = useState(true)
    const [idMethod, setIdMethod] = useState()
    const [name, setName] = useState()
    const [number, setNumber] = useState()
    const [expiry, setExpiry] = useState()
    const [month, setMonth] = useState()
    const [year, setYear] = useState()
    const [cvv, setCVV] = useState()


    const handleMethod = (id) => {
        setIdMethod(id)
        setDisabled(false)
    }
    const nextStep = () => {
        setStep(step + 1)
    }
    const forwardStep = () => {
        setStep(step - 1)
    }
    
    return (
        <div className='addPayMethod'>
            <div className="header">
                <div className="container">
                    <div className="icon" onClick={() => step === 0 ? navigate(-1) : forwardStep()}>
                        <ArrowBackIcon />
                    </div>
                    <p className='label epilogue'>Aggiungi metodo</p>
                    {
                        step === 0 || step === 5 || idMethod === 2 ? null : (

                        <div className="pagination">
                            <span className={step === 1 ? 'active' : ''}></span>
                            <span className={step === 2 ? 'active' : ''}></span>
                            <span className={step === 3 ? 'active' : ''}></span>
                            <span className={step === 4 ? 'active' : ''}></span>
                        </div>
                        )
                    }
                    {
                        idMethod === 2 && step !== 5 ? (
                            <div className="pagination">
                            <span className={step === 1 ? 'active' : ''}></span>
                            <span className={step === 2 ? 'active' : ''}></span>
                            <span className={step === 3 ? 'active' : ''}></span>
                        </div>
                        ) : null
                    }
                </div>
            </div>
            <div className="body">
                {idMethod === 1 && step === 5 ? (
                    <>
                        <p className="main">Aggiungi metodo di pagamento</p>
                    </>
                ) : idMethod === 1 ? (
                    <>
                        <p className="main">Aggiungi subito il tuo metodo di pagamento e risparmia</p>
                        <p className="secondary">
                            Collega il tuo conto o la tua carta per assicurarti il miglior prezzo.
                        </p>
                    </>
                ) : null}
                {idMethod === 2 && step === 5 ? (
                    <>
                        <p className="main">Aggiungi metodo di pagamento</p>
                    </>
                ) : idMethod === 2 ? (
                    <>
                        <p className="main">Aggiungi subito il tuo metodo di pagamento e risparmia</p>
                        <p className="secondary">
                            Collega il tuo conto o la tua carta per assicurarti il miglior prezzo.
                        </p>
                    </>
                ) : null}

                <div className="container">
                    {step === 0 ? (
                        <>
                            <p className="main p-16 mb-50">Seleziona metodo:</p>

                            <div className="method" onClick={() => handleMethod(1)}>
                                <div className="iconBox">
                                    <Card />
                                </div>
                                <div className="text">
                                    <p className="secondary">Carta di Credito</p>
                                </div> 
                                <div className="checkBox">
                                    {idMethod === 1 ? (
                                        <span className='active'></span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="method" onClick={() => handleMethod(2)}>
                                <div className="iconBox">
                                    <Bank />
                                </div>
                                <div className="text">
                                    <p className="secondary">SDD</p>
                                </div> 
                                <div className="checkBox">
                                    {idMethod === 2 ? (
                                        <span className='active'></span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="buttonActivate">
                                <button disabled={disabled} onClick={() => nextStep()}>
                                    Avanti <ArrowForwardIos fontSize='18px' />
                                </button>
                            </div>
                        </>
                    ) : step === 1 ? (
                        <Step1 step={step} setStep={setStep} idMethod={idMethod} setName={setName} name={name} />
                    ) : step === 2 ? (
                        <Step2 step={step} setStep={setStep} idMethod={idMethod} name={name} setNumber={setNumber} number={number} />
                    ) : step === 3 ? (
                        <Step3 step={step} setStep={setStep} idMethod={idMethod} name={name} number={number} setMonth={setMonth} month={month} setYear={setYear} year={year} setExpiry={setExpiry} expiry={expiry} />
                    ) : step === 4 ? (
                        <Step4 step={step} setStep={setStep} idMethod={idMethod} name={name} number={number} month={month} year={year} setCVV={setCVV} expiry={expiry}/>
                    ) : <Step5 idMethod={idMethod} name={name} number={number} cvv={cvv} expiry={expiry} month={month} year={year} />}
                </div>
               
            </div>
        </div>
    )
}

export default AddPayMethod
